import React from "react"
import PropTypes from "prop-types"

import { Trans } from "gatsby-plugin-react-i18next"

import * as spinnerStyles from "../../styles/Spinner.module.css"

function Spinner(props) {
  return (
    <span className={spinnerStyles.stage}>
      {props.message && <Trans>{props.message}</Trans>}
      <span
        className={`${spinnerStyles.dotPulse} ${
          props.message ? spinnerStyles.withMessage : ``
        }`}
      ></span>
    </span>
  )
}

Spinner.propTypes = {
  message: PropTypes.string,
}

export default Spinner
